import RESPONSE_DATA from '../data/responses.json';

// Advanced frontend-only mock response generator
// Simulates a high-quality legal AI response based on query patterns and document metadata

export const generateMockResponse = (question, fileName, tone = 'Formal', length = 'Medium', metadata = {}) => {
    const base = fileName || metadata?.title || 'the document';
    const q = (question || '').toLowerCase();
    const j = (metadata?.jurisdiction || '').toLowerCase();

    let answer = '';
    let refs = [];
    let confidence = 0.85;

    // --- 1. Determine Intent & Base Content ---

    // Find matching template from JSON
    const match = RESPONSE_DATA.find(item =>
        item.keywords.some(k => q.includes(k))
    ) || RESPONSE_DATA.find(item => item.id === 'fallback');

    if (match) {
        answer = match.template.replace(/\{base\}/g, base);
        refs = match.refs.map(r => ({
            title: r.title.replace('{base}', base),
            section_num: r.section_num
        }));
        confidence = match.confidence;
    }

    // --- 2. Tone Adjustments ---

    if (tone === 'Concise') {
        // Strip out bullets and keep the first paragraph or key sentences
        const sentences = answer.split('\n').filter(line => line.trim().length > 0 && !line.trim().startsWith('•') && !line.trim().startsWith('1.'));
        answer = sentences.slice(0, 2).join(' ').replace(/\*\*/g, '') + ' (Refer to the full text for details.)';
    }
    else if (tone === 'Detailed') {
        answer += `\n\n**Analysis:**\nFrom a legal perspective, these provisions are designed to reduce systemic risk. Practitioners should note that courts in ${j || 'this jurisdiction'} tend to interpret these clauses strictly against the drafting party (contra proferentem) where ambiguity exists. It is recommended to maintain comprehensive documentation to evidence compliance.`;
    }
    else if (tone === 'Neutral') {
        answer = answer.replace(/strictly/g, '').replace(/dissuasive/g, 'standard').replace(/severe/g, 'defined');
    }

    // --- 3. Length Adjustments ---

    if (length === 'Short') {
        // Similar to concise but maybe slightly more than just one sentence
        answer = answer.split('\n')[0] + '\n\nSee relevant sections for more.';
    }
    else if (length === 'Long') {
        answer += `\n\n**Further Context:**\nThis legislation does not operate in a vacuum. It should be read in conjunction with related regulations and circulars issued by the oversight body. Historically, amendments to this framework have focused on increasing transparency and aligning with international best practices. Stakeholders are advised to conduct regular gap analyses to ensure ongoing alignment with these evolving standards.`;
        confidence = Math.min(0.98, confidence + 0.02);
    }

    // --- 4. Metadata Context Injection ---

    if (metadata && metadata.jurisdiction) {
        answer += `\n\n*(Jurisdiction: ${metadata.jurisdiction})*`;
    }

    return { answer, refs, confidence };
}
